import { render, staticRenderFns } from "./TransactionsTableWeb.vue?vue&type=template&id=44918f80&scoped=true"
import script from "./TransactionsTableWeb.vue?vue&type=script&lang=js"
export * from "./TransactionsTableWeb.vue?vue&type=script&lang=js"
import style0 from "./TransactionsTableWeb.vue?vue&type=style&index=0&id=44918f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44918f80",
  null
  
)

export default component.exports